import { dateFormatter } from "src/utils/helperFunctions";
import React from "react";
import Link from "next/link";
interface Props {
  data: any;
}

const ArcheiveCount = ({ data }: Props) => {
  const [archeiveData, setArcheiveData] = React.useState([]);
  React.useEffect(() => {
    if (data?.length) {
      let blogGroups = {};
      data?.length &&
        data.map((blog: any) => {
          const thisBlogYear: any = new Date(blog._id).getFullYear();
          const prevBlogs = blogGroups[[thisBlogYear]] || [];
          blogGroups[[thisBlogYear]] = Object.assign([], [...prevBlogs, blog]);
        });
      const reverseOrder = Object.assign([], blogGroups).reverse();
      setArcheiveData(reverseOrder);
    }
  }, [data]);
  return (
    <div className="pt-4 mt-4 border-t">
      <p className="mb-4 text-lg font-medium dark:text-dark-text-primary">
        Archive
      </p>

      <div className="pr-8 mx-auto overflow-y-scroll max-h-56">
        {archeiveData.map((eachArcheiveData, eachInd) => (
          <div key={eachInd + 1 + ""}>
            <p className="mb-1 text-sm font-semibold dark:text-dark-text-primary">
              {new Date(eachArcheiveData[0]._id).getFullYear()}
            </p>
            <ul className="mb-2 text-xs dark:text-dark-text-secondary">
              {eachArcheiveData.map((blogMonth, idx) => (
                <li key={`archiveMonth${blogMonth._id}`}>
                  <Link href={`/blog/archive/${blogMonth._id}`}>
                    {new Date(blogMonth._id).toLocaleString("default", {
                      month: "long",
                    })}
                    {/* {moment(blogMonth._id, "YYYY-MM").format("MMMM")}  */}(
                    {blogMonth.count})
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArcheiveCount;
